import { createContext, MutableRefObject, useContext, useRef } from 'react';

const RoutePathContext = createContext<MutableRefObject<string> | null>(null);

export function useRoutePath() {
  const context = useContext(RoutePathContext);

  if (context === null) {
    throw new Error('useRoutePath must be called in RoutePathProvider.');
  }

  return context;
}

export function RoutePathProvider({ children }: { children: React.ReactNode }) {
  const routePathRef = useRef('');
  return <RoutePathContext.Provider value={routePathRef}>{children}</RoutePathContext.Provider>;
}
